import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import DashBoard from '@/components/DashBoard'
import FloatCharts from '@/components/charts/FloatCharts'
import MorrisCharts from '@/components/charts/MorrisCharts'
import Forms from '@/components/Forms'
import Tables from '@/components/Tables'
import Buttons from '@/components/ui-elements/Buttons'
import Icons from '@/components/ui-elements/Icons'
import Notifications from '@/components/ui-elements/Notifications'
import Panels from '@/components/ui-elements/Panels'
import Typography from '@/components/ui-elements/Typography'
import Persons from '@/components/pages/Persons'
import Activity from '@/components/pages/Activity'
import Sectors from '@/components/pages/Sectors'
import Rules from '@/components/pages/Rules'
import Configurations from '@/components/pages/Configurations'
import About from '@/components/pages/About'
import Users from '@/components/pages/Users'
import TimeLine from '@/components/pages/TimeLine'
import PageNotFound from '@/components/pages/PageNotFound'
import Locations from '@/components/pages/Locations'
import Login from '@/components/pages/Login'
import Logout from '@/components/pages/Logout'
import Profile from '@/components/pages/Profile'
import Landing from '@/components/pages/Landing'
import ConfirmToken from '@/components/pages/ConfirmToken'
import Certificates from '@/components/pages/Certificates'
import storage from '@/mixins/storage'
import MyProfile from '@/components/pages/MyProfile'
import RecoverPass from '@/components/pages/RecoverPass'
import MyPersons from '@/components/pages/MyPersons'
import Accreditations from '@/components/pages/Accreditations'
import MyAccreditations from '@/components/pages/MyAccreditations'
import EmitCertificate from '@/components/pages/EmitCertificate'
import PrintCertificate from '@/components/pages/PrintCertificate'
import DocumentTypes from '@/components/pages/DocumentTypes'
import RoutinesDashBoard from '@/components/pages/RoutinesDashBoard'
import RoutineSolicitation from '@/components/pages/RoutineSolicitation'
import Routines from '@/components/pages/Routines'

Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/admin/',
      name: 'Home',
      component: Home,
      children: [
        { path: '/admin/', name: 'DashBoard', component: DashBoard, meta: { requiresAuth: true} },
        { path: '/admin/float', name: 'FloatCharts', component: FloatCharts, meta: { requiresAuth: true} },
        { path: '/admin/morris', name: 'MorrisCharts', component: MorrisCharts, meta: { requiresAuth: true} },
        { path: '/admin/tables', name: 'Tables', component: Tables, meta: { requiresAuth: true} },
        { path: '/admin/forms', name: 'Forms', component: Forms, meta: { requiresAuth: true} },
        { path: '/admin/buttons', name: 'Buttons', component: Buttons, meta: { requiresAuth: true} },
        { path: '/admin/icons', name: 'Icons', component: Icons, meta: { requiresAuth: true} },
        { path: '/admin/notifications', name: 'Notifications', component: Notifications, meta: { requiresAuth: true} },
        { path: '/admin/panels', name: 'Panels', component: Panels, meta: { requiresAuth: true} },
        { path: '/admin/typography', name: 'Typography', component: Typography, meta: { requiresAuth: true} },
        { path: '/admin/configurations', name: 'Configurations', component: Configurations, meta: { requiresAuth: true} },
        { path: '/admin/persons', name: 'Persons', component: Persons, meta: { requiresAuth: true} },
        { path: '/admin/activity', name: 'Activity', component: Activity, meta: { requiresAuth: true} },
        { path: '/admin/sectors', name: 'Sectors', component: Sectors, meta: { requiresAuth: true} },
        { path: '/admin/rules', name: 'Rules', component: Rules, meta: { requiresAuth: true} },
        { path: '/admin/users', name: 'Users', component: Users, meta: { requiresAuth: true} },
        { path: '/admin/perfil', name: 'Profile', component: Profile, meta: { requiresAuth: true} },
        { path: '/admin/my-profile', name: 'MyProfile', component: MyProfile, meta: { requiresAuth: true} },
        { path: '/admin/about', name: 'About', component: About, meta: { requiresAuth: true} },
        { path: '/admin/timeline', name: 'TimeLine', component: TimeLine, meta: { requiresAuth: true} },
        { path: '/admin/certificates', name: 'Certificates', component: Certificates, meta: { requiresAuth: true} },
        { path: '/admin/my-persons', name: 'MyPersons', component: MyPersons, meta: { requiresAuth: true} },
        { path: '/admin/accreditations', name: 'Accreditations', component: Accreditations, meta: { requiresAuth: true} },
        { path: '/admin/my-accreditations', name: 'MyAccreditations', component: MyAccreditations, meta: { requiresAuth: true} },
        { path: '/admin/emit-certificate', name: 'EmitCertificate', component: EmitCertificate, meta: { requiresAuth: true} }, 
        { path: '/admin/locations', name: 'Locations', component: Locations, meta: { requiresAuth: true} },       
        { path: '/admin/routines-dashboard', name: 'RoutinesDashBoard', component: RoutinesDashBoard, meta: { requiresAuth: true} },         
        { path: '/admin/routine-solicitation', name: 'RoutineSolicitation', component: RoutineSolicitation, meta: { requiresAuth: true} },         
        { path: '/admin/document-types', name: 'DocumentTypes', component: DocumentTypes, meta: { requiresAuth: true} },
        { path: '/admin/routines', name: 'DocumentTypes', component: Routines, meta: { requiresAuth: true} },         
         
      ]
    },
    { path: '/certificate/print/:id', name: 'PrintCertificate', component: PrintCertificate, meta: { requiresAuth: true} },   
    { path: '/', name: 'Landing', component: Landing },
    { path: '/confirm-token', name: 'ConfirmToken', component: ConfirmToken },
    { path: '/login', name: 'Login', component: Login },
    { path: '/recover-pass', name: 'RecoverPass', component: RecoverPass },
    { path: '/logout', name: 'Logout', component: Logout },
    { path: '*', name: 'PageNotFound', component: PageNotFound }

  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const token = storage.methods.getToken()
    if (!token || tokenExpired(token)) {
      localStorage.removeItem("token")
      next({
        path: "/login",
        params: { nextUrl: to.fullPath },
      });
    } else {
        next();
    }
  } else {
    next();
  }
});

function tokenExpired(token) {
  const decodedToken = parseJwt(token);
  const expiration = new Date(decodedToken.exp * 1000);
  return expiration <= Date.now();
}

function parseJwt(token) {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};

export default router



// WEBPACK FOOTER //
// ./src/router/index.js